export default __webpack_public_path__ + "static/media/Culture.986fb934.svg";